import { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Slide from '@material-ui/core/Slide';

function TransitionUp(props) {
  return <Slide {...props} direction='up' />;
}

function SnackBar({ severity, vertical, horizontal, children }) {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Snackbar
      open={show}
      autoHideDuration={3000}
      onClose={handleClose}
      TransitionComponent={TransitionUp}
      vertical={vertical}
      horizontal={horizontal}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        MenuProps={{ keepMounted: true, disablePortal: true }}
      >
        {children}
      </Alert>
    </Snackbar>
  );
}

export default SnackBar;
